import moment from 'moment';
import config from '../config';
import TYPE_ALERT from '../constantValues/TYPE_ALERT';
import axios from 'axios/index';
import Alert from 'react-s-alert';

/**
 * Formatting event data.
 *
 * @param response response with events from backend.
 * @returns {*}
 */
function formatEventData(response) {
    if (response === null) {
        return [];
    } else {
        for (let i = 0; i < response.data.length; i++) {
            response.data[i].name =
                response.data[i].VacationInfo.Employee.name + ' ' + response.data[i].VacationInfo.Employee.surname;
            response.data[i].status = response.data[i].StatusVacation.status;
            response.data[i].type = response.data[i].TypeVacation.type;
            response.data[i].team = response.data[i].VacationInfo.Employee.Team.name;
        }
        return response;
    }
}

/**
 * Serves to format date.
 *
 * @param {string} cell - The date.
 * @return {string}     - Formatted date.
 */
function dateFormatter(cell) {
    return `${moment(cell).format('L')}`;
}

/**
 * Serves to format date.
 *
 * @param {string} cell - The date.
 * @return {string}     - Formatted date.
 */
function timeOfUpdateFormatter(cell) {
    return `${moment(cell).format('DD.MM.YY')} ${moment(cell).format('LT')}`;
}

/**
 * Serves to convert object on string.
 *
 * @param {object/string}   cell - Object to convert or string.
 * @return {object/string}  cell - Object converted or string.
 */
function objectConverter(cell) {
    if (typeof cell === 'object' && cell !== null) {
        return cell.label;
    } else {
        return cell;
    }
}

/**
 *The function serve to load with names employees
 *
 * @return {Promise}
 */
const optionsStaus = () => {
    let status = [];
    return axios
        .get(`${config.BACKEND_API_URL}/api/statusVacation`)
        .then(response => {
            if (response === null) {
                this.setState({ disabledSelect: true });
            } else {
                for (let i = 0; i < response.data.length; i++) {
                    status.push({
                        value: response.data[i].id,
                        label: response.data[i].status
                    });
                }
                return { options: status };
            }
        })
        .catch(() => {
            this.setState({ disabledSelect: true });
            Alert.error(TYPE_ALERT.WRONG_CONNECT_DATABASE);
        });
};
/**
 * The function serve to load with type vacation
 *
 * @return {Promise}
 */
const optionsType = () => {
    let type = [];
    return axios
        .get(`${config.BACKEND_API_URL}/api/typeVacation`)
        .then(response => {
            if (response === null) {
                this.setState({ disabledSelect: true });
            } else {
                for (let i = 0; i < response.data.length; i++) {
                    type.push({
                        value: response.data[i].id,
                        label: response.data[i].type
                    });
                }
                return { options: type };
            }
        })
        .catch(() => {
            this.setState({ disabledSelect: true });
            Alert.error(TYPE_ALERT.WRONG_CONNECT_DATABASE);
        });
};
/**
 * It will compare two tables, check  they are the same,
 *
 * @param {array} array - Array of object to compare.
 * @return {boolean}    - The result of   the comparison.
 */
// eslint-disable-next-line
Array.prototype.equals = function(array) {
    // if the other array is a falsy value, return
    if (!array) return false;

    // compare lengths - can save a lot of time
    if (this.length !== array.length) return false;
    for (let i = 0, l = this.length; i < l; i++) {
        // Check if we have nested arrays
        if (this[i] instanceof Array && array[i] instanceof Array) {
            // recurse into the nested arrays
            if (!this[i].equals(array[i])) return false;
        } else if (this[i] !== array[i]) {
            // Warning - two different object instances will never be equal: {x:20} != {x:20}
            return false;
        }
    }
    return true;
};

/**
 * Fills the table of events with data.
 * @param {Object} response          Response with events data from backend.
 * @param {Boolean} isAdminOrManager Permissions to edit and delete events
 * @returns {Table} Return sorted data to events table.
 */
function fillInTypeColumns(response, isAdminOrManager) {
    if (response === null) return [];
    let tableToAccept = [],
        tablePlanning = [],
        tableDuring = [],
        tableDone = [],
        tableMedicalLeave = [],
        tableRejected = [];
    for (let i = 0; i < response.data.length; i++) {
        switch (response.data[i].StatusVacation.status) {
            case 'Do rozpatrzenia':
                tableToAccept.push(response.data[i]);
                break;
            case 'W trakcie':
                tableDuring.push(response.data[i]);
                break;
            case 'Zaakceptowane':
                tablePlanning.push(response.data[i]);
                break;
            case 'Zakończone':
                tableDone.push(response.data[i]);
                break;
            case 'L4':
                tableMedicalLeave.push(response.data[i]);
                break;
            case 'Odrzucony':
                tableRejected.push(response.data[i]);
                break;
            default:
                break;
        }
    }

    if (isAdminOrManager === true) {
        return [
            {
                event: tableToAccept,
                name: 'Do rozpatrzenia',
                permissionsToEditAndDelete: true,
                enablePrint: true
            },
            {
                event: tablePlanning,
                name: 'Zaplanowane',
                permissionsToEditAndDelete: true,
                enablePrint: true
            },
            {
                event: tableDuring,
                name: 'W trakcie',
                permissionsToEditAndDelete: true,
                enablePrint: true
            },
            {
                event: tableDone,
                name: 'Zakończone',
                permissionsToEditAndDelete: true,
                enablePrint: true
            },
            {
                event: tableMedicalLeave,
                name: 'L4',
                permissionsToEditAndDelete: true,
                enablePrint: false
            },
            {
                event: tableRejected,
                name: 'Odrzucony',
                permissionsToEditAndDelete: true,
                enablePrint: false
            }
        ];
    } else if (isAdminOrManager === false) {
        return [
            {
                event: tableToAccept,
                name: 'Do rozpatrzenia',
                permissionsToEditAndDelete: true,
                enablePrint: true
            },
            {
                event: tablePlanning,
                name: 'Zaplanowane',
                permissionsToEditAndDelete: false,
                enablePrint: true
            },
            {
                event: tableDuring,
                name: 'W trakcie',
                permissionsToEditAndDelete: false,
                enablePrint: false
            },
            {
                event: tableDone,
                name: 'Zakończone',
                permissionsToEditAndDelete: false,
                enablePrint: false
            },
            {
                event: tableMedicalLeave,
                name: 'L4',
                permissionsToEditAndDelete: false,
                enablePrint: false
            },
            {
                event: tableRejected,
                name: 'Odrzucony',
                permissionsToEditAndDelete: false,
                enablePrint: false
            }
        ];
    } else if (isAdminOrManager === null) {
        return [
            {
                event: tablePlanning,
                name: 'Zaplanowane',
                permissionsToEditAndDelete: false,
                enablePrint: false
            },
            {
                event: tableDuring,
                name: 'W trakcie',
                permissionsToEditAndDelete: false,
                enablePrint: false
            }
        ];
    }
}

/**
 * Serves to format eligibility.
 *
 * @param {boolean} cell - The eligibility.
 * @return {string}     - Formatted eligibility.
 */
function yearsFormater(cell) {
    if (cell === true) {
        return 'Otwarty';
    } else if (cell === false) {
        return 'Nie otwarty';
    } else {
        return 'Błąd';
    }
}

/**
 * Check out new value and returns proper status.
 *
 * @param {string} regex - Regular expression.
 * @param {string} field - Value to validations.
 * @param {string} currentValue - Current value with db.
 * @return {string} Status of validation.
 */
function validation(regex, field, currentValue) {
    let result = regex.test(field);
    if (currentValue === null || field === '') return null;
    else if (currentValue === field) return null;
    else if (result === true) return 'success';
    else if (result === false) return 'error';
}

function validateNumber(number, max, reg) {
    return (
        Number.isInteger(Number.parseInt(number, 10)) &&
        number <= Number.parseInt(max, 10) &&
        number > 0 &&
        reg.test(number)
    );
}

function resetLocalStorage() {
    let hours = 24; // Reset when storage is more than 24hours
    let now = new Date().getTime();
    let setupTime = localStorage.getItem('setupTime');
    if (setupTime === null) {
        localStorage.setItem('setupTime', now);
    } else {
        if (now - setupTime > hours * 60 * 60 * 1000) {
            sessionStorage.clear();
            localStorage.setItem('setupTime', now);
        }
    }
}

export {
    formatEventData,
    dateFormatter,
    objectConverter,
    optionsStaus,
    optionsType,
    fillInTypeColumns,
    timeOfUpdateFormatter,
    yearsFormater,
    validation,
    validateNumber,
    resetLocalStorage
};



// WEBPACK FOOTER //
// ./src/utils/utils.js